module.exports = __webpack_public_path__ + "img/9.20b6ec63.jpg";